import { ScheduledTradingHours, StoreAddress } from '@jbhi-fi/apis/src/algolia/types/AlgoliaStoreData';
import { format, parseISO } from 'date-fns';

export const DAYS_OF_WEEK = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];

export const formatStoreAddress = (storeAddress: StoreAddress) => {
  const { Line1 = '', Line2 = '', Line3 = '', Suburb = '', State = '', Postcode = '' } = storeAddress ?? {};
  return {
    AddressLine1: Line1,
    AddressLine2: Line2,
    AddressLine3: Line3,
    Suburb,
    State,
    Postcode,
  };
};

const getFormattedTradingDayOfWeek = (storeHours: ScheduledTradingHours, storeDate: string) => {
  const now = new Date();
  const dateToday = new Date().toLocaleDateString('en-CA');
  const isStoreCurrentlyOpen =
    storeHours.IsOpen && now >= new Date(storeHours.OpeningDateTime) && now <= new Date(storeHours.ClosingDateTime);
  return dateToday === storeDate
    ? isStoreCurrentlyOpen
      ? 'Open today'
      : 'Today'
    : `${DAYS_OF_WEEK[storeHours.DayOfWeek]}`;
};

const getFormattedTradingDate = (storeDate: string) => {
  return new Date(storeDate).toLocaleDateString('en-GB', {
    day: 'numeric',
    month: 'short',
  });
};

const stripTimezone = (dateTimeString: string) => {
  return dateTimeString.replace(/([+-]\d{2}:\d{2}|Z)$/, '');
};

const formatTime = (date: Date) => {
  return format(date, 'h:mma').toLowerCase().replace(':00', '');
};

const getFormattedTradingHours = (storeHours: ScheduledTradingHours) => {
  if (storeHours.IsOpen) {
    const openingTimeParsed = parseISO(stripTimezone(storeHours.OpeningDateTime));
    const closingTimeParsed = parseISO(stripTimezone(storeHours.ClosingDateTime));

    const formattedOpeningTime = formatTime(openingTimeParsed);
    const formattedClosingTime = formatTime(closingTimeParsed);

    return `${formattedOpeningTime} - ${formattedClosingTime}`;
  }

  return 'Closed';
};

export const formatStoreHours = (storeHoursForWeek: Array<ScheduledTradingHours>) => {
  return storeHoursForWeek.map(storeHoursDay => {
    const storeDate = storeHoursDay.Date.split('T')[0];
    return {
      DayOfWeek: getFormattedTradingDayOfWeek(storeHoursDay, storeDate),
      Date: getFormattedTradingDate(storeDate),
      Hours: getFormattedTradingHours(storeHoursDay),
    };
  });
};
